import type { ErrorListOutput, FullAddress } from '../../types';

export type BuildingSchema = {
  id: string;
  name: string;
  fullAddress: FullAddress;
};

export interface GetOrganisationSuccessResponse {
  buildingByOrganisationName: {
    buildings: BuildingSchema[];
  };
}

export interface GetOrganisationErrorResponse {
  buildingByOrganisationName: ErrorListOutput & {
    buildings: never;
  };
}

export type GetOrganisationResponse =
  | GetOrganisationSuccessResponse
  | GetOrganisationErrorResponse;

export const GET_ORGANISATION_BUILDING_BY_NAME = (name: string) => `query {
  buildingByOrganisationName(name: "${name}") {
    ... on ErrorListOutput {
      errors {
        type
        message
      }
    }
    ... on BuildingsOutput {
      buildings {
        fullAddress {
          addressNumber
          country
          municipality
          neighborhood
          postalCode
          region
          street
          subAddressNumber
          label
        }
        id
        name
      }
    }
  }
}`;
